import axios from "axios";

function isValidPiAddress(address) {
  const baseUrl = "https://api.mainnet.minepi.com";

  return axios
    .get(`${baseUrl}/accounts/${address}`)
    .then((res) => {
      return Boolean(res.status == 200 && res.data.id);
    })
    .catch((error) => {
      return false;
    });
}

export default {
  isValidAddress(address, currency, networkType) {
    return isValidPiAddress(address);
  },
};
